import { AxiosResponse } from "axios";
import { axiosInstance } from "../../AxiosInterceptor";
import { getRegistrationMetaViewModel, createScorecardExternalRedirect, createGroupModuleExternalRedirect, createConsolidatedScorecardExternalRedirect} from "./ApiUrl.CreateScorecard";

export const createScorecardService = {
    CreateScorecard:(scorecardId : string): Promise<AxiosResponse<string[]>> => {
        return axiosInstance.get(`${getRegistrationMetaViewModel}?id=${scorecardId}`)
            .then((response) => {
                window.location.href = (`${createScorecardExternalRedirect}${scorecardId}`);
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error;
            });
    },

    CreateGroupModule:(scorecardId : string): void => {
        window.location.href = (`${createGroupModuleExternalRedirect}${scorecardId}`);
    },

    CreateConsolidatedScorecard:(scorecardId : string): void => {
        window.location.href = (`${createConsolidatedScorecardExternalRedirect}${scorecardId}`);
    }
};
